import { z } from 'zod'

export const signAgreementsSearchSchema = z.object({
  ids: z.array(z.string()).catch([]),
})

export type SignAgreementsSearch = z.infer<typeof signAgreementsSearchSchema>
